"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELegalStatus = void 0;
exports.ELegalStatus = {
    legal: "legal",
    natural: "natural",
};
